<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="transactions"
      :loading="loading"
      item-key="id"
      no-data-text="Không có phiếu nào"
      :server-items-length="totalItems"
      :footer-props="{
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page-options': [10, 20, 50]
      }"
      @update:options="onOptionsChange"
    >
      <template v-slot:item.code="{ item }">
        <a class="font-weight-bold primary--text" @click="onViewDetail(item)">{{ item.code }}</a>
      </template>

      <template v-slot:item.type="{ item }">
        <v-chip small :color="getTypeColor(item.type)" dark>
          {{ getTypeLabel(item.type) }}
        </v-chip>
      </template>

      <template v-slot:item.itemCount="{ item }">
        <span>{{ (item.items && item.items.length) || 0 }} thiết bị</span>
      </template>

      <template v-slot:item.fromLocation="{ item }">
        <span>{{ get(item, 'fromLocation.name', '-') }}</span>
      </template>

      <template v-slot:item.toLocation="{ item }">
        <span>{{ get(item, 'toLocation.name', '-') }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon small color="primary" @click="onViewDetail(item)" title="Xem chi tiết phiếu">
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
        <v-btn icon small color="error" @click="onRemove(item)" title="Xóa phiếu">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Dialog chi tiết phiếu -->
    <TransactionDetailDialog :state="detailDialog" :item="selectedItem" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import TransactionDetailDialog from '@/modules/facility/transaction/TransactionDetailDialog.vue'

const headers = [
  { text: 'Mã phiếu', value: 'code', align: 'left', sortable: false },
  { text: 'Tiêu đề', value: 'title', align: 'left', sortable: false },
  { text: 'Loại phiếu', value: 'type', align: 'center', sortable: false },
  { text: 'Số món', value: 'itemCount', align: 'center', sortable: false },
  { text: 'Từ phòng', value: 'fromLocation', align: 'left', sortable: false },
  { text: 'Đến phòng', value: 'toLocation', align: 'left', sortable: false },
  { text: 'Ngày thực hiện', value: 'transactionDate', align: 'center', sortable: false },
  { text: 'Thao tác', value: 'actions', align: 'center', sortable: false, width: '100px' }
]

export default {
  name: 'TransactionDataTable',
  components: { TransactionDetailDialog },
  data() {
    return {
      headers,
      detailDialog: false,
      selectedItem: null
    }
  },
  computed: {
    ...mapState('FacilityTransactions', ['transactions', 'totalItems', 'pageText', 'loading'])
  },
  methods: {
    get,
    ...mapActions('FacilityTransactions', ['requestPageSettings', 'searchTransactionList', 'removeTransaction']),
    async refresh(query) {
      this.searchTransactionList(query || {})
    },
    onOptionsChange({ page, itemsPerPage }) {
      this.requestPageSettings({ page, itemsPerPage })
    },
    getTypeLabel(type) {
      switch (type) {
        case 'IMPORT': return 'Nhập kho'
        case 'EXPORT': return 'Xuất kho'
        case 'TRANSFER': return 'Luân chuyển'
        case 'LIQUIDATION': return 'Thanh lý'
        default: return type
      }
    },
    getTypeColor(type) {
      switch (type) {
        case 'IMPORT': return 'success'
        case 'EXPORT': return 'warning'
        case 'TRANSFER': return 'indigo'
        case 'LIQUIDATION': return 'error'
        default: return 'blue-grey'
      }
    },
    onViewDetail(item) {
      this.selectedItem = item
      this.detailDialog = !this.detailDialog
    },
    onRemove(item) {
      this.$dialog.confirm({
        title: 'Thông báo xác nhận',
        text: `Bạn có chắc muốn xóa phiếu "${item.code}"?`,
        okText: 'Xóa',
        cancelText: 'Hủy',
        done: async () => {
          this.$loading.active = true
          try {
            await this.removeTransaction(item.id)
            this.$alert.deleteSuccess()
          } catch (error) {
            this.$alert.deleteError(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
